<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información de la Página</h1>
    <div class="information" v-if="page">
      <p v-if="page.title" class="information__text"><strong class="information__text--strong">Título: </strong>{{page.title}}</p>
      <p v-if="page.excerpt" class="information__text"><strong class="information__text--strong">Resumen: </strong><br><span v-html="excerpt"></span></p>
      <p v-if="page.date" class="information__text"><strong class="information__text--strong">Fecha de Publicación: </strong>{{page.date|date}}</p>
      <p v-if="page.date" class="information__text"><strong class="information__text--strong">Hora de Publicación: </strong>{{page.date|hour}}</p>
      <p v-if="status" class="information__text"><strong class="information__text--strong">Estatus: </strong>{{status}}</p>
      <p v-if="page.content" class="information__text"><strong class="information__text--strong">Contenido: </strong><br><span v-html="page.content"></span></p>
      <p v-if="page.cover" class="information__text"><strong class="information__text--strong">Cover de la página:</strong></p>
      <img v-if="page.cover" :src="cover" :alt="page.title" class="information__image information__image--wide">
    </div>
  </div>
</template>

<script>
import {page_status} from './mocks'
import {nl2br} from '@/core/libs/functions'
import {config} from '@/core/config/base'
export default {
  props: {
    page: {
      type: Object
    }
  },
  computed: {
    status: function () {
      let status = page_status.filter(element => element.id === this.page.status_id)
      return status[0].name
    },
    excerpt: function () {
      return nl2br(this.page.excerpt)
    },
    cover: function () {
      let img = ''
      if (this.page.cover) {
        img = config.statics.url + JSON.parse(this.page.cover).sizes.small
      }
      return img
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/view.vue